<app-settings-card
  title="Tipos de relatórios"
  description="Seleccione os relatórios que este tenant poderá visualizar e gerar."
  icon="fas fa-file-lines"
  [badge]="control.value.length + ' activos'"
>
  <div class="reports-grid">
    @for (report of options; track report.id) {
      <label
        class="report-option"
        [class.enabled]="isEnabled(report.id)"
        [class.disabled]="disabled"
      >
        <input
          type="checkbox"
          [checked]="isEnabled(report.id)"
          [disabled]="disabled"
          (change)="toggle(report.id, $any($event.target).checked)"
        />
        <span class="report-icon"><i [class]="report.icon"></i></span>
        <span class="report-copy">
          <strong>{{ report.nome }}</strong>
          <small>{{ report.descricao }}</small>
        </span>
        <span class="switch" aria-hidden="true"><span></span></span>
      </label>
    }
  </div>
</app-settings-card>
